import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const METADATA_RULE_EDITOR_CLASS_NAME = 'MetadataRuleEditor';
export const METADATA_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type MetadataRuleEditorClassSlot =
	(typeof METADATA_RULE_EDITOR_CLASS_SLOTS)[number];

export interface MetadataRuleEditorClasses {
	root: string;
}

export type MetadataRuleEditorClassKey = keyof MetadataRuleEditorClasses;

export const getMetadataRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(METADATA_RULE_EDITOR_CLASS_NAME, slot);

export const metadataRuleEditorClasses: MetadataRuleEditorClasses =
	generateUtilityClasses(METADATA_RULE_EDITOR_CLASS_NAME, ['root']);

export default metadataRuleEditorClasses;
